import React from "react";
import { Box, Container, Grid, Stack, Typography, Chip } from "@mui/material";
import Iconify from "../../components/Iconify";
import Reveal from "../../components/Reveal";
import { INK, ACCENT } from "../../theme/brand";

const MINI_STEPS = [
  { icon: "mdi:eye-outline", title: "Vorschau prüfen", text: "Alle fälligen Beiträge auf einen Blick, vor jeder Abbuchung." },
  { icon: "mdi:check-decagram-outline", title: "Bestätigen", text: "Ein Klick statt Datei-Export und Bank-Upload." },
  { icon: "mdi:send-circle-outline", title: "Direkt eingereicht", text: "MartialVerse reicht die Abbuchung digital bei der Bank ein." },
];

export default function NewFeature() {
  return (
    <Box
      id="neu"
      sx={{ py: { xs: 8, md: 12 }, scrollMarginTop: { xs: 56, md: 72 } }}
    >
      <Container maxWidth="lg">
        <Reveal
          sx={{
            bgcolor: INK,
            color: "#fff",
            borderRadius: 4,
            p: { xs: 3, sm: 5, md: 7 },
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "-40%",
              right: "-10%",
              width: 420,
              height: 420,
              background: "radial-gradient(circle, rgba(139,127,234,0.25) 0%, transparent 70%)",
              pointerEvents: "none",
            }}
          />

          <Grid container spacing={5} alignItems="center" sx={{ position: "relative" }}>
            <Grid item xs={12} md={6}>
              <Chip
                label="Neu"
                size="small"
                sx={{
                  bgcolor: "rgba(139,127,234,0.18)",
                  color: ACCENT,
                  fontWeight: 700,
                  mb: 2,
                }}
              />
              <Typography variant="h3" component="h2" fontWeight={800} letterSpacing="-0.02em" sx={{ mb: 2 }}>
                Direkt digital abbuchen – ganz ohne SEPA-Datei
              </Typography>
              <Typography sx={{ color: "rgba(255,255,255,0.65)", fontSize: 17 }}>
                Schluss mit SEPA-Datei exportieren, ins Online-Banking wechseln
                und hochladen: MartialVerse reicht fällige Beiträge nach
                deiner Bestätigung direkt digital bei der Bank ein – mit
                derselben Vorschau wie gewohnt, nur einen Klick entfernt.
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Stack spacing={2.5}>
                {MINI_STEPS.map((step, i) => (
                  <Stack key={step.title} direction="row" spacing={2} alignItems="flex-start">
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        bgcolor: "rgba(139,127,234,0.16)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <Iconify icon={step.icon} width={20} sx={{ color: ACCENT }} />
                    </Box>
                    <Box>
                      <Typography variant="subtitle1" component="h3" fontWeight={700}>
                        {i + 1}. {step.title}
                      </Typography>
                      <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.55)" }}>
                        {step.text}
                      </Typography>
                    </Box>
                  </Stack>
                ))}
              </Stack>
            </Grid>
          </Grid>
        </Reveal>
      </Container>
    </Box>
  );
}
